export const clampNumberToBounds = (
  value: number,
  minBound?: number,
  maxBound?: number
): number => {
  let next = value;
  const hasMin = typeof minBound === 'number' && isFinite(minBound);
  const hasMax = typeof maxBound === 'number' && isFinite(maxBound);
  if (hasMin || hasMax) {
    const min = hasMin ? (minBound as number) : -Infinity;
    const max = hasMax ? (maxBound as number) : Infinity;
    next = Math.max(min, Math.min(next, max));
  }
  return next;
};

export const clampRangeToBounds = (
  range: [number, number],
  minBound?: number,
  maxBound?: number
): [number, number] => {
  let [a, b] = range;
  a = clampNumberToBounds(a, minBound, maxBound);
  b = clampNumberToBounds(b, minBound, maxBound);
  if (a > b) return [b, a];
  return [a, b];
};
